import { render, staticRenderFns } from "./WcUploadersFile.vue?vue&type=template&id=3635a1bc&lang=pug&"
import script from "./WcUploadersFile.vue?vue&type=script&lang=js&"
export * from "./WcUploadersFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports